import React, { createContext } from "react";

const AuthContext = createContext({
  token: null,
  isAuthenticated: false,
  user: null,
  loading: false,
  msg: null,
  email: null,
  login: () => {},
  logout: () => {}
});

export default AuthContext;